/**
 * Typography design tokens from Figma (Queen One Design System).
 * Source: Typography variable collection.
 */

export const typography = {
  fontFamily: "Inter",
  fontWeight: {
    light: 300,
    regular: 400,
    medium: 500,
    semiBold: 600,
    bold: 700,
  },
  /** Base font size in px (1rem) */
  baseFontSize: 16,
  /** Font sizes in px. Key = rem value (e.g. "0.75rem" → 12px) */
  fontSize: {
    "0.625rem": 10,
    "0.75rem": 12,
    "0.8125rem": 13,
    "0.875rem": 14,
    "0.9375rem": 15,
    "1rem": 16,
    "1.25rem": 20,
    "1.5rem": 24,
    "2.125rem": 34,
    "3rem": 48,
    "3.75rem": 60,
    "6rem": 96,
  },
} as const;
